import { defineRecipe } from "@chakra-ui/react";

export default defineRecipe({
  variants: {
    variant: {
      outline: {
        background: "bg",
        borderWidth: "0",
        boxShadow: "input",

        _focusVisible: {
          boxShadow: "focusRing",
          outline: "none",
        },
      },
    },

    size: {
      md: {
        borderRadius: "l2",
        height: "9",
        minHeight: "9",
      },
    },
  },
});
